import styled from 'styled-components';
import LoginLogoSvg from '../../../assets/onboardingNew/homepage/login-logo.svg';

const LoginLogoIcon = styled(LoginLogoSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.4rem'};
height: ${props => props.height || '2.4rem'};
margin-right:0.5rem;
display: flex;
`;

export default LoginLogoIcon;
